const BASE = "https://customer-assets-0z36b82j.emergentagent.net/job_osmand-course-signup/artifacts";

export const LOGOS = {
  offroadHorizontal: `${BASE}/9brh86pm_OFFROAD%20ITALIA%20LOGO%202025.jpeg`,
  offroadVertical: `${BASE}/jyivmmpx_OFF%20ROAD%20ITALIA%20logo%20verticale.jpg`,
  osmandBanner: `${BASE}/fqpw6ipb_logo%20osmand.jfif`,
  osmandPin: `${BASE}/qm3mnl9u_logo%20osmand%202.jfif`,
};

export const IMAGES = {
  fourByFour:
    "https://images.unsplash.com/photo-1662564481624-4ac2a2294126?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHw0eDQlMjBvZmZyb2FkJTIwdmVoaWNsZSUyMG1vdW50YWluJTIwdHJhaWwlMjBtdWR8ZW58MHx8fHwxNzg0NjQ3NzYyfDA&ixlib=rb-4.1.0&q=85",
};
